import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

import {black500, greyishBlue100} from "assets/jss/main";

const CarouselImage = forwardRef(function CarouselImage({image, selected = false, onClick = () => {}}, ref) {
    return (
        <div
            ref={ref}
            onClick={onClick}
            style={{
                display: 'flex',
                flexShrink: 0,
                width: '72px',
                height: '96px',
                border: `1px solid ${selected ? black500 : greyishBlue100}`,
                borderRadius: '8px',
                cursor: 'pointer'
            }}
        >
            <img src={image} alt={'product image'} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px',
            }}/>
        </div>
    );
});

CarouselImage.propTypes = {
    image: PropTypes.string,
    selected: PropTypes.bool
};

export default CarouselImage;
